interface terms {
    term: string;
    status: string;
}
interface deliveries {
    deliveryValue: string;
    deliveryLabel: string;
    term: string;
}

class PCSearchCustomRender {
    static customRender(item)
    {
        if(item.hasOwnProperty('recordObj'))
        {
            item.recordObj.internationalAvailable = "";
            if(item.recordObj.hasOwnProperty("internationalStudents"))
            {
                if(item.recordObj.internationalStudents.accepted == true){
                    item.recordObj.internationalAvailable = "International applicants accepted";
                }else{
                    item.recordObj.internationalAvailable = "Not open to international applicants";
                }
            }
            /*if(item.recordObj.hasOwnProperty("intakeDates"))
            {
                //Get all intake date objects
                if(item.recordObj.intakeDates.dates !== null)
                {
                    let datesObj = item.recordObj.intakeDates.dates;
                    let strterms: Array<string> = [];
                    let deliveries: Array<deliveries> = [];

                    datesObj.forEach(dateItem => {
                        if(dateItem!== null){
                            if(dateItem.deliveryMethod!==null){
                                dateItem.deliveryMethod.forEach(deliveryItem => {
                                    let programStatus = deliveryItem.programStatus != null ? deliveryItem.programStatus  : "";
                                    if(programStatus == "closed"){
                                        if(deliveryItem.allowsInternational == "yes"){
                                            if(deliveryItem.internationalProgramStatus){
                                                if(deliveryItem.internationalProgramStatus != "closed"){
                                                    programStatus = deliveryItem.internationalProgramStatus;
                                                }
                                            }
                                        }
                                    }
                                    let delType  = deliveryItem.deliveryType != null ? deliveryItem.deliveryType : "";
                                    deliveries.push(PCSearchCustomRender.getDeliveryType(delType, programStatus));
                                    //strterms.push(deliveryItem.programStatus);
                                })
                            }
                        }
                    })

                    let numDeliveryTypes = deliveries.length;
                    if(numDeliveryTypes > 0)
                    {
                        //sort the deliveries by terms/status
                    let sortedDeliveryArr = PCSearchCustomRender.sortTerms(deliveries); 
                    if(sortedDeliveryArr[0] !== null && sortedDeliveryArr[0] !== undefined)
                    {
                            let term = sortedDeliveryArr[0].term;
                            let status = PCSearchCustomRender.getProgramStatus(term);
                            let delivery = sortedDeliveryArr[0].deliveryLabel;
                            let isDeliveryEqual = PCSearchCustomRender.checkAllStrEqual(sortedDeliveryArr);
                            if(sortedDeliveryArr.length > 1 && !isDeliveryEqual) {
                                delivery = "Multiple";
                            }
                            item.delivery = delivery;
                            item.status = status;
                            item.classStatus = status!== "" ? item.status.toLowerCase() : "d-none";
                        }
                    }
                }
            }
            else if(item.recordObj.hasOwnProperty("destinyCourses")){
                if(item.recordObj.destinyCourses.courseDelivery !== null)
                {
                    item.delivery = PCSearchCustomRender.addSpaceBetweenUpperCase(item.recordObj.destinyCourses.courseDelivery);
                    item.status = PCSearchCustomRender.getProgramStatus(item.recordObj.destinyCourses.courseStatus);
                    item.classStatus = item.recordObj.destinyCourses.courseStatus;
                }
            }
            else{
                //TODO Handle?
                item.delivery = "";
                item.status = "";
            }
            
            //Credential format
            if(item.recordObj.credential !== null)
            {   
                let credential = PCSearchCustomRender.getCredential(item.recordObj.credential);
                let creds = credential.charAt(0).toUpperCase() + credential.slice(1);
                item.credential = creds;
            }

            //New Program
            if(item.recordObj.newProgram === "true")
            {
                item.label = {
                    type: "new",
                    title: "New!"
                }
            }*/
        }
        return item;
    }

    static pcCustomFilter(value: string): string|undefined {
        //This is for Con Ed pages filters facets. ConEd have different dataset
        if(value == "ContinuingEducation") {
            return "recordObj.destinyCourses.courseDelivery";
        }
        return undefined;
    }

    static addSpaceBetweenUpperCase(strWord : string): string {
        return strWord.replace(/([A-Z])/g, ' $1').trim()
    }

    static sortTerms(deliveries: Array<deliveries>) : Array<deliveries>
    {
        const priority = [ "open", "ongoing", "waitlisted", "pending", "closed"];
        let sortDeliveryArr = deliveries.sort( ( a, b ) => priority.indexOf( a.term ) - priority.indexOf( b.term ) );
        return sortDeliveryArr;
    }

    static checkAllStrEqual(deliveries: Array<deliveries>): boolean
    {
        if(typeof deliveries !== 'undefined')
        {
            var firstElement = deliveries[0].deliveryLabel;
            return deliveries.every(function(element) {
                return element.deliveryLabel === firstElement;
            });
        }
        return false;
    }

    static getCredential(credential : string)
    {
        if(credential == 'JourneyPerson'){
            return "Journeyperson";
        }
        else if(credential == "Course - no credential awarded"){
            return "Course";
        }
        else{
            return credential;
        }
    }
    
    static getProgramStatus(strStatuses : string): string {
        if (strStatuses.includes("open")) {
            return "Open";
        }
        else if(strStatuses.includes("ongoing")){
            return "Ongoing";
        }
        else if(strStatuses.includes("waitlisted")){
            return "Waitlisted";
        }
        else if(strStatuses.includes("pending")){
            return "Pending";
        }
        else if(strStatuses.includes("closed")){
            return "Closed";
        }
        else{
            return "";
        }
    }
    /* TODO: To remove after testing. This shouldn't be needed
    static getDeliveryType(deliveryVal: string, term: string): deliveries
    {
        if (deliveryVal.toLowerCase().includes('on-campus day')) {
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'On-Campus Day',
                term: term
            }
        } else if (deliveryVal.toLowerCase().includes('on-campus evening/weekend')) {
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'On-Campus (Evening/Weekend)',
                term: term
            }
        } else if (deliveryVal.toLowerCase().includes('online day')) {
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'Online Day',
                term: term
            }
        } else if (deliveryVal.toLowerCase().includes('online evening/weekend')) {
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'Online (Evening/Weekend)',
                term: term
            }
        }
        else if (deliveryVal.toLowerCase().includes('online flexible delivery')) {
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'Online (Flexible)',
                term: term
            }
        }
        else if (deliveryVal.toLowerCase().includes('blended delivery - both on-campus and online')) {
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'Blended',
                term: term
            }
        }
        else if(deliveryVal.toLowerCase().includes('rural')){
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'Rural',
                term: term
            }
        }
        else if(deliveryVal.toLowerCase().includes('interprovincial')){
            return {
                deliveryValue: deliveryVal,
                deliveryLabel: 'Interprovincial',
                term: term
            }
        }
        else
        {
            return {
                deliveryValue: '',
                deliveryLabel: '',
                term: ''
            }
        }
    }*/
}

export default PCSearchCustomRender;
export type { terms, deliveries };